import { observable, decorate, action } from 'mobx'
import axios from 'axios'

const initialState = {
  state: {
    email: '',
    companies: [],
    name: '',
    isFetching: false
  }
}

class GenerateTokenStore {
  constructor (rootStore) {
    this.state = {
      ...initialState.state
    }
    this.rootStore = rootStore.stores
  }

  handleChange (value, name) {
    this.state[name] = value
  }

  setCompanies (selectedCompanies) {
    this.state.companies = selectedCompanies.map(data => {
      return {id: data.value, name: data.label}
    })
  }

  resetState () {
    this.state = {...initialState.state}
  }

  generateToken (event,) {
    event.preventDefault()
    this.state.isFetching = true
    const url = process.env.REACT_APP_AWS_URL + '/generateToken'
    const { email, companies, name } = this.state
    axios.post(url, {
      email: email,
      empresas: companies,
      nome: name
    })
      .then(response => {
        if (response.data.errorMessage) {
          this.rootStore.notificationStore.sendErrorNotification('Erro!', response.data.errorMessage)
        } else {
          this.rootStore.notificationStore.sendSuccessNotification('Pronto!', 'O token foi gerado e enviado para o email ' + this.state.email)
          this.state = {...initialState.state}
        }
        this.state.isFetching = false
      })
      .catch(error => {
        console.log(error)
        this.rootStore.notificationStore.sendErrorNotification('Erro!', 'Não foi possível enviar o token')
        this.state.isFetching = false
      })
  }
}

decorate(GenerateTokenStore, {
  state: observable,
  handleChange: action,
  generateToken: action
})

export default GenerateTokenStore



// WEBPACK FOOTER //
// ./src/stores/generateTokenStore.js